import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "font-bold" }

import { ref } from 'vue'
import { mdiAlert } from '@mdi/js'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import ModalVue from '@/components/designSystem/modals/Modal.vue'
import OutlineButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'confirm.delete.action',
  props: {
  show: {
    type: Boolean,
    required: true
  },
  title: {
    type: String,
    default: 'Atenção, confirme a exclusão'
  },
  description: {
    type: String,
    default: 'Você tem certeza que deseja excluir esse registro?'
  },
  textButton: {
    type: String,
    default: 'Deletar'
  },
  isLoading: {
    type: Boolean,
    default: false
  },
  showJustification: {
    type: Boolean,
    default: false
  },
  justificationLabel: {
    type: String,
    default: 'Justificativa'
  }
},
  emits: ["closeModal", "handleConfirm"],
  setup(__props, { emit }) {

const props = __props;





const justification = ref('')
const showError = ref(false)

function handleConfirm() {
  if (props.showJustification && !justification.value.trim()) {
    showError.value = true
    return
  }
  emit('handleConfirm', props.showJustification ? justification.value.trim() : undefined)
}

function handleClose() {
  justification.value = ''
  showError.value = false
  emit('closeModal')
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(ModalVue, {
    onClose: handleClose,
    modalActive: __props.show,
    hasFooterBorder: true,
    isFilterModal: ""
  }, {
    header: _withCtx(() => [
      _createElementVNode("p", _hoisted_1, _toDisplayString(__props.title), 1)
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_v_row, { class: "pt-4" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            md: "6"
          }, {
            default: _withCtx(() => [
              _createVNode(FilledButton, {
                "data-testid": "confirm-action-cancel-button",
                onClick: handleClose,
                width: "100%",
                text: "Cancelar"
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "12",
            md: "6"
          }, {
            default: _withCtx(() => [
              _createVNode(OutlineButton, {
                "data-testid": "confirm-action-confirm-button",
                loading: __props.isLoading,
                onClick: handleConfirm,
                text: __props.textButton,
                height: "52px",
                width: "100%",
                color: "primary"
              }, null, 8, ["loading", "text"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createVNode(_component_v_row, { "no-gutters": "" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, {
                color: "warning",
                size: "100",
                icon: _unref(mdiAlert)
              }, null, 8, ["icon"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, { cols: "12" }, {
            default: _withCtx(() => [
              _createElementVNode("p", {
                class: _normalizeClass(["text-center", __props.showJustification ? 'mb-4' : ''])
              }, _toDisplayString(__props.description), 3)
            ]),
            _: 1
          }),
          (__props.showJustification)
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 0,
                cols: "12"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_textarea, {
                    modelValue: justification.value,
                    "onUpdate:modelValue": [
                      _cache[0] || (_cache[0] = ($event: any) => ((justification).value = $event)),
                      _cache[1] || (_cache[1] = ($event: any) => (showError.value = false))
                    ],
                    label: '* ' + __props.justificationLabel,
                    variant: "outlined",
                    rows: "3",
                    "auto-grow": "",
                    "error-messages": showError.value ? 'Justificativa é obrigatória' : []
                  }, null, 8, ["modelValue", "label", "error-messages"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modalActive"]))
}
}

})